import { GlobalStyle } from "./globalStyles";
import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";

// Lazy load components
const Home = lazy(() => import("./Pages/Home"));
const Tarifs = lazy(() => import("./Pages/Tarifs")); // Import the Tarifs component
const Blog = lazy(() => import("./Pages/Blog")); // Import the Tarifs component
const Order = lazy(() => import("./Pages/Order")); // Import the Order component
const Header = lazy(() => import("./components/Header/index")); // Original Header
const Header2 = lazy(() => import("./components/Header2/index")); // Header2 for Tarifs and Order
const Footer = lazy(() => import("./components/Footer/index"));
const ScrollToTop = lazy(() => import("./components/ScrollToTop/index"));

const App = () => {
  const location = useLocation();

  // Determine if the current path is either /tarifs or /order
  const isTarifsOrOrderPage = location.pathname === '/tarifs' || location.pathname === '/order' || location.pathname === '/blog';

  return (
    <>
      {isTarifsOrOrderPage ? <Header2 /> : <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/tarifs" element={<Tarifs />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/order" element={<Order />} />
      </Routes>
      <Footer />
    </>
  );
};

function MainApp() {
  return (
    <Router>
      <Suspense fallback={<div>Loading...</div>}>
        <GlobalStyle />
        <ScrollToTop />
        <App />
      </Suspense>
    </Router>
  );
}

export default MainApp;